//=include _owl.carousel.min.js
//=include _anime.min.js
//=include _jquery.flipster.min.js
//=include _jquery.matchHeight-min.js

$(document).ready(function() {
	var animate_svg = false;
	var carrousel_players = {};

	// Gestion du scroll
	handle_scroll();
	$(window).scroll(function() {
		handle_scroll();
	});

	if ($('#carrousel_accueil').length > 0) {
		var carrousel_accueil = $('#carrousel_accueil');
		carrousel_accueil.on('initialized.owl.carousel', function(event) {
			handleVideo();
		});
		carrousel_accueil.owlCarousel({
			loop: true,
			dots: false,
			nav: true,
			items: 1,
			margin: 0,
			lazyLoad: true,
			autoplay: false,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			animateIn: 'fadeIn',
			animateOut: 'fadeOut'
		});
		carrousel_accueil.on('translated.owl.carousel', function(event) {
			handleVideo();
		});
		function handleVideo() {
			var current_slide = $('#carrousel_accueil .owl-item.active .carrousel_slide');
			var video_url = current_slide.data('video-url');
			var video_container = current_slide.find('.carrousel_player');
			if (video_url !== undefined) {
				carrousel_accueil.trigger('stop.owl.autoplay');
				if (carrousel_players[video_container.attr('id')] !== undefined) {
					carrousel_players[video_container.attr('id')].play();
				} else {
					$.getScript('https://player.vimeo.com/api/player.js', function() {
						var player = new Vimeo.Player(video_container.attr('id'), {
							url: video_url,
							autoplay: true,
							background: true,
							byline: false,
							controls: false,
							dtn: true,
							loop: false,
							muted: true,
							portrait: false,
							quality: 'auto',
							responsive: false,
							title: false,
							width: 1920
						});
						player.on('ended', function() {
							player.setCurrentTime(0);
							carrousel_accueil.trigger('next.owl.carousel');
							carrousel_accueil.trigger('play.owl.autoplay');
						});
						carrousel_players[video_container.attr('id')] = player;
					});
				}
			}
		}
	}

	if ($('#carrousel_ambassadeurs li').length > 1) {
		$('#carrousel_ambassadeurs').flipster({
			itemContainer: 'ul',
			itemSelector: 'li',
			start: 0,
			fadeIn: 400,
			loop: true,
			autoplay: false,
			pauseOnHover: true,
			style: 'flat',
			spacing: -0.3,
			click: true,
			keyboard: true,
			scrollwheel: false,
			touch: true,
			nav: false,
			buttons: true,
			buttonPrev: 'Previous',
			buttonNext: 'Next',
			onItemSwitch: false
		});
	}

	if ($('#carrousel_actualites').length > 0) {
		var carrousel_actualites = $('#carrousel_actualites');
		carrousel_actualites.owlCarousel({
			loop: true,
			nav: false,
			lazyLoad: true,
			items: 1,
			margin: 60,
			autoplay: false
		});
	}

	var type_html = $('#type').html();
	$('#sport').on('change', function() {
		var sport = $(this).val();
		if (sport) {
			/*$('#type option').removeAttr('disabled');
			$('#type option').not($('#type option[data-parent="' + sport + '"]')).attr('disabled', 'disabled');
			if ($('#type option:selected').is(':disabled')) {
				$('#type').val('');
			}*/
			$('#type').html(type_html);
			$('#type option').not($('#type option[data-parent="' + sport + '"]')).remove();
		} else {
			//$('#type').val('');
			$('#type').html(type_html);
		}
	});
	$('#type').on('change', function() {
		var sport = $('#sport').val();
		var type = $(this).val();

		if (!sport) {
			$('#sport').val($('#type option:selected').data('parent'));
		}
	});

	if ($('.bloc_categorie').length > 0) {
		$('.bloc_categorie').each(function() {
			create_bloc_categorie_svg($(this));
		});
		$('.bloc_categorie_titre').bind('resize', function(e) {
			$(this).parents('.bloc_categorie').find('svg').remove();
			create_bloc_categorie_svg($(this).parents('.bloc_categorie'));
		});
		function create_bloc_categorie_svg(bloc_categorie) {
			var titre = bloc_categorie.find('.bloc_categorie_titre');
			var titre_height = titre.height();
			var svg_height = titre_height + 20;
			var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
			svg.setAttribute('version', '1.0');
			svg.setAttribute('width', '260');
			svg.setAttribute('height', svg_height);
			svg.setAttribute('viewBox', '0 0 260 ' + svg_height);
			svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
			svg.style.marginTop = '-' + (svg_height / 2) + 'px';
			titre.after(svg);

			var svg_g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
			svg_g.setAttribute('fill', 'none');
			svg_g.setAttribute('stroke', '#fff');
			svg_g.setAttribute('stroke-width', 5);
			svg.appendChild(svg_g);

			var svg_path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
			svg_path.setAttribute('d', 'm100 0 H 0 V ' + svg_height + ' H 260 V 0 H 160');
			svg_g.appendChild(svg_path);
		}

		$(window).scroll(function() {
			if ($(window).scrollTop() > ($('.blocs_categories').position().top - $(window).height()) && !animate_svg) {
				animate_svg = true;

				anime({
					targets: '.bloc_categorie path',
					strokeDashoffset: [anime.setDashoffset, 0],
					easing: 'easeInOutSine',
					duration: 3000,
					delay: function(el, i) { return i * 250 + 1000 },
					direction: 'alternate',
					loop: false
				});
			}
		});
	}
});

$(window).load(function() {
	$('.icone_titre').matchHeight({
		byRow: true
	});
});

function handle_scroll() {
	if ($(window).scrollTop() > 0) {
		$('.header').addClass('fixed');
	} else {
		$('.header').removeClass('fixed');
	}
}
